import { useEffect, useState, useRef, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import useAlert from 'hooks/useAlert';

const UserMap = ({ setValue, initPosition }) => {
  const defaultPosition = [36.752887, 3.042048]; // Coordinates for Algiers
  const [position, setPosition] = useState(initPosition || defaultPosition); // Use initPosition if provided

  return (
    <MapContainer
      center={position}
      zoom={13}
      style={{ height: '55vh', width: '100%' }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <UserMarker setValue={setValue} position={position} setPosition={setPosition} initPosition={initPosition} />
    </MapContainer>
  );
};

const UserMarker = ({ setValue, position, setPosition, initPosition }) => {
  const markerRef = useRef(null);
  const { showAlerts } = useAlert();

  // Event handlers for marker dragging
  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          const newPos = marker.getLatLng();
          setPosition(newPos);
          setValue('location.coordinates',newPos); // Update position to parent component if needed
        }
      },
    }),
    [setValue, setPosition]
  );

  // Detect user position if initPosition is not provided
  const map = useMapEvents({
    locationfound(e) {
      if (!initPosition) {
        setPosition(e.latlng);
        map.flyTo(e.latlng, map.getZoom());
      }
    },
    locationerror() {
      if (!initPosition) {
        showAlerts({
          title: 'Localisation',
          type: 'toast',
          msg: "Votre position n'a pas pu être détectée. Vous êtes positionné à Alger par défaut.",
          color: 'info',
        });
        setPosition([36.752887, 3.042048]); // Fallback to Algiers
      }
    },
  });

  useEffect(() => {
    if (!initPosition) {
      map.locate(); // Try to get the user's location if initPosition is not set
    }
  }, [map, initPosition]);

  return (
    <Marker
      draggable={true}
      eventHandlers={eventHandlers}
      position={position}
      ref={markerRef}
    >
      <Popup>
        <span>Déplacez ce marqueur pour définir votre position exacte.</span>
      </Popup>
    </Marker>
  );
};

export default UserMap;
